module.exports = __webpack_public_path__ + "img/Singapore.278c58d4.jpg";